// extracted by mini-css-extract-plugin
export default {"titulo":"CancelarReserva_titulo__MM+HK","container":"CancelarReserva_container__mYXF1","titulo-caja":"CancelarReserva_titulo-caja__gKFhT","body":"CancelarReserva_body__vAkA3"};